import axios from "../../../axios";
export const getPastOrderList = () => {
  const response = axios.get(`orders/past-orders/`);
  return response;
};
